import React, { Component } from "react";

class Modal extends Component {
    render() {
        return (
            <div
                className="modal__overlay"
                style={{ display: this.props.show ? "flex" : "none" }}
                onClick={e => {
                    if (e.target.className === "modal__overlay") {
                        this.props.hideModal();
                    }
                }}
            >
                <div className="modal">
                    <div
                        className="modal__close-button"
                        onClick={ () => { this.props.hideModal() } }
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path d="M6.34314575 6.34314575L17.6568542 17.6568542M6.34314575 17.6568542L17.6568542 6.34314575"/>
                        </svg>
                    </div>
                    <h1 className="heading heading--medium">
                        <span role="img" aria-label="handshake">🙌</span><br/>
                        Thanks for downloading Ikonate!
                    </h1>
                    <div className="modal__tweet">
                        <p className="text text--light">Show your <span role="img" aria-label="love">❤️</span> by sharing our work on Twitter</p>
                        <p><a className="button button--twitter" href="https://twitter.com/home?status=Check%20out%20Ikonate%20%E2%80%93%20fully%20customisable%20and%20accessible%20vector%20icons%20by%20%40mikolajdobrucki%20%26%20%40ucreate_%20http%3A//ikonate.com" target="_blank" rel="noopener noreferrer" aria-label="Tweet about Ikonate">Tweet</a></p>
                    </div>
                    <p>
                        <a className="text text--link text--github" href="https://github.com/eucalyptuss/ikonate" target="_blank" rel="noopener noreferrer">Github</a>
                        <a className="text text--link text--github" href="https://github.com/eucalyptuss/ikonate#usage" target="_blank" rel="noopener noreferrer">How to use</a>
                        <a className="text text--link text--twitter" href="http://twitter.com/mikolajdobrucki" target="_blank" rel="noopener noreferrer">Twitter</a>
                    </p>
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js